module.exports = __webpack_public_path__ + "media/native-apps/vastmanland-7d70dfc3.webp";